import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Lightbulb, TrendingUp, Clock, Settings, MessageCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: '/chat', label: 'LEE', icon: MessageCircle },
    { path: '/dashboard', label: 'Home', icon: Home },
    { path: '/inventions', label: 'Inventions', icon: Lightbulb },
    { path: '/opportunities', label: 'Opps', icon: TrendingUp },
    { path: '/scheduled', label: 'Tasks', icon: Clock },
    { path: '/settings', label: 'Settings', icon: Settings },
  ];

  const isActive = (path) => {
    if (path === '/dashboard') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-background border-t border-border z-50 md:hidden">
      <div className="flex justify-around items-center h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              data-testid={`mobile-bottom-${item.label.toLowerCase().replace(/ /g, '-')}`}
              className={cn(
                "flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors",
                active
                  ? "text-primary"
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <Icon className={cn("h-5 w-5", active && "stroke-[2.5]")} />
              <span className={cn(
                "text-xs",
                active && "font-semibold"
              )}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
